import { useTranslation } from "react-i18next";
import { useCmsContent } from "@/hooks/use-cms-content";

/**
 * Returns a function `c(cmsKey, i18nKey)` that:
 * - When the current language is pt-PT (default), returns CMS value if available, otherwise the i18n translation.
 * - For any other language, always returns the i18n translation.
 */
export const useLocalizedContent = () => {
  const { content, loading } = useCmsContent();
  const { t, i18n } = useTranslation();
  const isPt = i18n.language === "pt-PT" || i18n.language === "pt";

  const c = (cmsKey: string, i18nKey: string, fallback?: string): string => {
    if (isPt && content[cmsKey]) {
      return content[cmsKey];
    }
    const translated = t(i18nKey);
    // i18next returns the key itself if no translation found
    if (translated && translated !== i18nKey) {
      return translated;
    }
    // fallback to CMS content even for non-PT if no translation exists
    return content[cmsKey] || fallback || translated;
  };

  return { c, content, loading, isPt };
};
